import storeConfig from 'Stores/1vo7kwhfwv-1/config';

try {
  storeConfig.InitFunc?.();
} catch (e) {
  console.error(e);
  import('Diagnostics/diagnostics')
    .then(({ logRuntimeError }) => logRuntimeError({ source: 'init_func', error: e }))
    .catch(() => {});
}
